import React, { memo } from 'react'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './FullHeightContainer.scss'
const rootClassName = 'full-height-container'

interface FullHeightContainerProps {
  header?: React.ReactNode
  fixedFooter?: React.ReactNode
  verticalPadding?: boolean
  horizontalPadding?: boolean
  children?: React.ReactNode
}

function FullHeightContainer(props: FullHeightContainerProps) {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-row-header`}>{props.header}</div>
      <div
        className={getMergedClassNames([
          `${rootClassName}-row-content`,
          props.verticalPadding ? 'vertical-padding' : '',
          props.horizontalPadding ? 'horizontal-padding' : ''
        ])}
      >
        {props.children}
      </div>
      {props.fixedFooter ? (
        <div className={`${rootClassName}-row-footer`}>{props.fixedFooter}</div>
      ) : undefined}
    </div>
  )
}

FullHeightContainer.defaultProps = {
  verticalPadding: true,
  horizontalPadding: true
}

export default memo(FullHeightContainer)
